import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CategorySinglePage } from '../category-single/category-single';

@Component({
    selector: 'page-category-results',
	templateUrl: 'category-results.html'
})
export class CategoryResultsPage {

    title: string;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.title = navParams.get('data');
    }

    /**
     * goToResult
     */
    public goToResult($item) {
        this.navCtrl.push(CategorySinglePage, {
            data: $item
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/category-results/category-results.ts